var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 3.8 5.7 1.7c-.4-.4-1-.4-1.4 0l-.2.2c-1.3 1.3-2 3-1.4 4.7.6 1.7 1.9 4 4.4 6.5 2.5 2.5 4.8 3.8 6.5 4.4 1.7.6 3.4-.1 4.7-1.4l.2-.2c.4-.4.4-1 0-1.4l-2.1-2.1c-.4-.4-1-.4-1.4 0-.8.8-2 .8-2.8 0L7.8 8.1C7 7.3 7 6 7.8 5.2c.4-.3.4-1 0-1.4z"
  })));
};
export default SvgPhone;